module.exports = __webpack_public_path__ + "img/history.1f605c06.png";